// extracted by mini-css-extract-plugin
export var container = "MainHeader-module--container--2GWD6";
export var inner = "MainHeader-module--inner--1dtd3";